import { useEffect, useMemo, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import InformationUpdateButons from "../components/Addresses/Edit/InformationUpdateButons";
import InformationUpdateForms from "../components/Addresses/Edit/InformationUpdateForms";
import InformationBulkUpdateItemsList from "../components/Addresses/Edit/InformationBulkUpdateItemsList";
import InformationBulkUpdateFiltersList from "../components/Addresses/Edit/InformationBulkUpdateFiltersList";
import checkboxIcon from "../assets/images/check_box_rgb_red.svg";
import { getAddressesByIds } from "../services/addressApi";

const InformationBulkUpdate = () => {
  const location = useLocation();
  const searchArea = location.state?.searchArea;

  // Extract and validate selected IDs from query param
  const selectedIds = useMemo(() => {
    const params = new URLSearchParams(location.search);
    const raw = params.get("ids");
    if (!raw) return [];
    const ids = raw
      .split(",")
      .map((s) => s.trim())
      .filter((s) => s && !isNaN(Number(s)));
    return [...new Set(ids)];
  }, [location.search]);

  const [filters, setFilters] = useState([]);
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [missingIds, setMissingIds] = useState([]);
  const [formActions, setFormActions] = useState(null);
  // const resolvedCount = addresses.filter((item) => !item.__missing).length;
  const totalSelected = selectedIds.length;
  const activeFiltersCount = filters.length + (searchArea ? 1 : 0);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const filterEntries = Array.from(params.entries()).filter(
      ([key]) => key !== "ids",
    );
    setFilters(filterEntries);
  }, [location.search]);

  useEffect(() => {
    let active = true;
    async function fetchData() {
      if (!selectedIds.length) {
        setAddresses([]);
        setMissingIds([]);
        return;
      }
      setLoading(true);
      try {
        const data = await getAddressesByIds(selectedIds);
        if (!active) return;
        setAddresses(data);
        const missing = data.filter((a) => a.__missing).map((a) => a.id);
        setMissingIds(missing);
      } catch (e) {
        if (!active) return;
      } finally {
        if (active) setLoading(false);
      }
    }
    fetchData();
    return () => {
      active = false;
    };
  }, [selectedIds]);

  return (
    <div className="information-layer-container information-bulk-update-page">
      <Container fluid>
        <div className="information-bulk-update-page__header mb-3">
          <Row>
            <Col>
              <div className="d-flex align-items-center">
                <img
                  src={checkboxIcon}
                  alt="Checkbox Icon"
                  style={{ width: "30px", height: "30px", marginRight: "12px" }}
                />
                <h3
                  style={{ fontSize: "1.5rem", fontWeight: "bold", margin: 0 }}
                >
                  Masowy Update Informacji
                </h3>
              </div>
            </Col>
          </Row>

          <div className="information-bulk-update-summary-strip">
            <div className="information-bulk-update-summary-chip">
              <span>Wybrane ID</span>
              <strong>{totalSelected}</strong>
            </div>
            <div className="information-bulk-update-summary-chip">
              <span>Aktywne filtry</span>
              <strong>{activeFiltersCount}</strong>
            </div>
            {/* <div className="information-bulk-update-summary-chip">
              <span>Znalezione rekordy</span>
              <strong>{resolvedCount}</strong>
            </div> */}
          </div>
        </div>

        <Row className="mb-4 gx-3 gy-3 align-items-start information-bulk-update-page__layout">
          <Col
            xl={6}
            lg={6}
            md={12}
            className="information-bulk-update-page__form-column"
          >
            <div className="information-bulk-update-panel information-bulk-update-panel--editor">
              <div className="information-bulk-update-panel__header"></div>
              <InformationUpdateForms
                selectedIds={selectedIds}
                changedRecords={addresses}
                addressFilterDto={filters}
                searchArea={searchArea}
                onRegisterActions={setFormActions}
              />
              {formActions && (
                <InformationUpdateButons
                  onReset={formActions.onReset}
                  onSave={formActions.onSave}
                  isSaving={formActions.isSaving}
                  isSaveDisabled={formActions.isSaveLocked}
                />
              )}
            </div>
          </Col>
          <Col
            xl={6}
            lg={6}
            md={12}
            className="information-bulk-update-page__details-column"
          >
            <Row className="mb-3 gx-3">
              <Col xs={12}>
                <div className="information-bulk-update-panel information-bulk-update-panel--filters">
                  <div className="information-bulk-update-panel__header">
                    <div>
                      <h2 className="information-bulk-update-panel__title">
                        Filtry
                      </h2>
                    </div>
                  </div>
                  <InformationBulkUpdateFiltersList
                    items={filters}
                    searchArea={searchArea}
                  />
                </div>
              </Col>
            </Row>
            <Row className="gx-3">
              <Col xs={12}>
                <div className="information-bulk-update-panel information-bulk-update-panel--preview">
                  <div className="information-bulk-update-panel__header">
                    <div>
                      <h2 className="information-bulk-update-panel__title">
                        Rekordy
                      </h2>
                    </div>
                  </div>
                  <InformationBulkUpdateItemsList
                    addresses={addresses}
                    loading={loading}
                    selectedIds={selectedIds}
                    missingIds={missingIds}
                  />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default InformationBulkUpdate;
